import { ProductCategory } from "../valuablesConstants";

export const isBikeProductCategory = (product: ProductCategory): boolean =>
  [ProductCategory.BIKE, ProductCategory.EL_BIKE].includes(product);

export const isClothesProductCategory = (product: ProductCategory): boolean =>
  [ProductCategory.FUR_COAT, ProductCategory.NATIONAL_COSTUME].includes(
    product,
  );
